var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10.1055C2.25 7.89633 4.04086 6.10547 6.25 6.10547C7.35457 6.10547 8.25 5.21004 8.25 4.10547V3.60547C8.25 2.77704 8.92157 2.10547 9.75 2.10547H14.75C15.5784 2.10547 16.25 2.77704 16.25 3.60547V4.10547C16.25 5.21004 17.1454 6.10547 18.25 6.10547C20.4591 6.10547 22.25 7.89633 22.25 10.1055V17.1055C22.25 19.8669 20.0114 22.1055 17.25 22.1055H7.25C4.48858 22.1055 2.25 19.8669 2.25 17.1055V10.1055Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.1055C16.25 16.3146 14.4591 18.1055 12.25 18.1055C10.0409 18.1055 8.25 16.3146 8.25 14.1055C8.25 11.8963 10.0409 10.1055 12.25 10.1055C14.4591 10.1055 16.25 11.8963 16.25 14.1055Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.b98494623923fee76f900738a79485aa.svg";
export { ForwardRef as ReactComponent };